module.exports = __webpack_public_path__ + "img/login-logo.56d78d3c.png";